export default "__VITE_ASSET__BELMqZN7__"